import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultTrue} from 'module/Properties/util/PropertiesUtil'

export const PlanEventConfigDict = {
	enabled: {
		label: 'Buchungsplan',
		type: 'boolean',
		defaultValue: false,
		defaultOverrideSelector: selPropGen(PropID.planTemplDefault, propDefaultTrue),
		visibleSelector: selPropGen(PropID.planTemplVis, propDefaultTrue),
	},
} as const